import React, { useEffect, useState } from "react";
import "../localMunicipalCouncil/LocalMunicipalCouncil.css";
import "../../../assets/fonts/Fonts.css";
import { stateImages } from "../CoatOfArms";
import { Link } from "react-router-dom";
import api from "../../../services/baseUrl";
export default function LandLaw() {
  const [states, setStates] = useState([]);

  useEffect(() => {
    const fetchLibraries = async () => {
      try {
        const response = await api.get(
          "/api/egazette-documents/libraries/all",

          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const filteredResponse = response.data.filter(
          (item) => item.orderId !== null
        );

        setStates(filteredResponse);
      } catch (error) {}
    };
    fetchLibraries();
  }, []);

  // const replaceSpacesWithNbsp = (text) => {
  //   if (!text || typeof text !== "string") {
  //     return text; // Return as-is if text is not a string or is null/undefined
  //   }
  //   return text.replace(/ /g, "\u00A0");
  // };
  return (
    <div className="">
      <div className="local-municipal-council-content">
        
        <div className="local-municipal-council-announcement">
          Access the latest gazetted regulations and enactments relating 
          <br /> to land matters within the Federal Territories and State jurisdictions.
        </div>
        <div
          className="local-municipal-council-state-gallery"
          style={{ padding: "35px" }}
        >
          {states.map((item, index) => (
            <Link key={index} to={`${item.id}`} className="gallery-item">
              <img
                src={stateImages[index]}
                alt={`${item.name} Logo`}
                className="gallery-image"
              />
              <p className="gallery-name">{item.displayName}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
